var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup714(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 136,
    viewBox: "0 0 209 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 190,
    height: 114,
    rx: 6,
    fill: "#F4F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.1801 51.67C53.0751 51.655 52.9401 51.655 52.8201 51.67C50.1801 51.58 48.0801 49.42 48.0801 46.765C48.0801 44.05 50.2701 41.845 53.0001 41.845C55.7151 41.845 57.9201 44.05 57.9201 46.765C57.9051 49.42 55.8201 51.58 53.1801 51.67Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M63.1101 61.57C60.4401 64.015 56.9001 65.5 53.0001 65.5C49.1001 65.5 45.5601 64.015 42.8901 61.57C43.0401 60.16 43.9401 58.78 45.5451 57.7C49.6551 54.97 56.3751 54.97 60.4551 57.7C62.0601 58.78 62.9601 60.16 63.1101 61.57Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 65.5C61.2843 65.5 68 58.7843 68 50.5C68 42.2157 61.2843 35.5 53 35.5C44.7157 35.5 38 42.2157 38 50.5C38 58.7843 44.7157 65.5 53 65.5Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 0.5H204.5C206.709 0.5 208.5 2.29086 208.5 4.5V11.5",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V11.5",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 135.5H204.5C206.709 135.5 208.5 133.709 208.5 131.5V124.5",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 135.5H4.5C2.29086 135.5 0.5 133.709 0.5 131.5V124.5",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 32.5,
    width: 70,
    height: 11,
    rx: 5.5,
    fill: "#D8E2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 49.5,
    width: 21,
    height: 5,
    rx: 2.5,
    fill: "#D8E2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 157.5 49.5)",
    fill: "#D8E2FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 67.5,
    width: 79,
    height: 4,
    rx: 2,
    transform: "rotate(180 166.5 67.5)",
    fill: "#D8E2FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 72.5 93.5)",
    fill: "#D8E2FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 66.5 103.5)",
    fill: "#D8E2FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 77.5 111.5)",
    fill: "#D8E2FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 125.5 111.5)",
    fill: "#D8E2FF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 173.5 111.5)",
    fill: "#D8E2FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 102.5 103.5)",
    fill: "#D8E2FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 137.5 103.5)",
    fill: "#D8E2FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 115.5 93.5)",
    fill: "#D8E2FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 158.5 93.5)",
    fill: "#D8E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup714);
export default __webpack_public_path__ + "static/media/Group 714.a582a95b075933d1d241ce91da983d6b.svg";
export { ForwardRef as ReactComponent };